const r = {
  isError: !1
};
export { r as HelpTextDefaultProps };